import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function TopVendorsCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.finTopVendorsChart !== 'undefined') {
      window.finTopVendorsChart.canvas = chartRef.current;
      window.finTopVendorsChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">Top Vendors by Spend</h3>
        <span className="click-tag">Click bars for vendor 360°</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="finTopVendors" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
